<template>
    <div>
        <b-modal
            :id="modalId"
            :ref="modalRef"
            size="sm"
            centered
            hide-footer
            header-class="header-nipige-class"
        >
            <template #modal-header>
                <div class="w-100 text-center text-dark font-weight-bold">
                    Select Date
                </div>
            </template>

            <b-input class="mb-2" type="date" v-model="startDate"></b-input>

            <span class="validate-error" v-if="startDate && !validStartDate">
                Start Date is not valid
            </span>

            <b-input type="date" v-model="endDate"></b-input>

            <span class="validate-error" v-if="endDate && !validEndDate">
                End Date is not valid
            </span>

            <div class="text-center mt-2">
                <b-button
                    @click="calculateDate"
                    class="my-0 mt-2"
                    variant="success"
                    :disabled="!validStartDate || !validEndDate"
                >
                    Find
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        modalRef: {
            type: String,
            default: "date-range-modal",
        },
        modalId: {
            type: String,
            default: "date-range1",
        },
    },
    data() {
        return {
            startDate: "",
            endDate: "",
            initialScrollTop: 0,
        };
    },
    computed: {
        validStartDate() {
            if (!this.startDate) return false;
            if (moment().diff(this.startDate, "hour") <= 0) return false;
            return true;
        },
        validEndDate() {
            if (!this.endDate) return false;
            if (moment().diff(this.endDate, "hour") <= 0) return false;
            if (moment(this.endDate).diff(this.startDate, "day") <= 0)
                return false;
            return true;
        },
    },
    methods: {
        calculateDate() {
            const data = {
                fromDate: this.startDate,
                toDate: this.endDate,
            };
            this.$emit("customDateRange", data);
            this.startDate = null;
            this.endDate = null;
            this.$refs[`${this.modalRef}`].hide();
        },
        openModal() {
            if (document.activeElement) {
                document.activeElement.blur();
            }

            setTimeout(() => {
                this.$refs[`${this.modalRef}`].show();
                this.startDate = null;
                this.endDate = null;
            }, 0);
        },

        handleModalShow() {
            // Save initial scroll position when modal is opened
            this.initialScrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            // Scroll to top when modal is shown
            document.documentElement.scrollTop = 0;
        },
        handleModalHidden() {
            // Restore initial scroll position after modal is hidden
            document.documentElement.scrollTop = this.initialScrollTop;
        },
    },
};
</script>
